var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7 3V2.6C7 2.03995 7 1.75992 6.89101 1.54601C6.79513 1.35785 6.64215 1.20487 6.45399 1.10899C6.24008 1 5.96005 1 5.4 1H4.6C4.03995 1 3.75992 1 3.54601 1.10899C3.35785 1.20487 3.20487 1.35785 3.10899 1.54601C3 1.75992 3 2.03995 3 2.6V3M4 5.75V8.25M6 5.75V8.25M0.5 3H9.5M8.5 3V8.6C8.5 9.44008 8.5 9.86012 8.33651 10.181C8.1927 10.4632 7.96323 10.6927 7.68099 10.8365C7.36012 11 6.94008 11 6.1 11H3.9C3.05992 11 2.63988 11 2.31901 10.8365C2.03677 10.6927 1.8073 10.4632 1.66349 10.181C1.5 9.86012 1.5 9.44008 1.5 8.6V3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.81f8d7e10220ae2f8a75bcafa798bef4.svg";
export { ForwardRef as ReactComponent };